/**
 * Utilidad para parsear datos para selects
 * Extraída de Applications para eliminar dependencias
 * 
 * @param {Object} data - Objeto de datos
 * @param {string} name - Nombre a usar como label
 * @returns {Object} Objeto parseado con label y value
 */
export const parseDataBySelect = (data, name) => {
    if (!data) return null;
    
    return {
        ...data,
        label: name || data.name || data.title || data.email || 'Sin nombre',
        value: data._id || data.id || data.value || name
    };
};

export default parseDataBySelect;

